/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.publicQrCodeScan

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.publicQrCodeScan.ScanningPublicQrCodeApi
import features.publicQrCodeScan.models.PublicQrCodeScanResponseModel
import features.publicQrCodeScan.serializeScanningPublicQrCodeState
import features.publicQrCodeScan.models.ScanPublicQrCodeRequest

import kotlinx.serialization.decodeFromString

/**
 * Scan a QR code. [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("ScanningPublicQrCodeApi")
class ScanningPublicQrCodeApiJs {

    /**
     * Scan a QR code.
     */


    
    fun scanPublicQrCode(overrideHeaders: String?,
serializedScanPublicQrCodeRequest: String): Promise<String?>  {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

        return GlobalScope.promise {
            val result = ScanningPublicQrCodeApi().scanPublicQrCode(
            overrideHeaders = decodedOverrideHeaders,
                scanPublicQrCodeRequest = Json.decodeFromString(
                    serializedScanPublicQrCodeRequest
                )
            ).toJsonResult<PublicQrCodeScanResponseModel>()

           return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    fun observeScanningPublicQrCodeState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        ScanningPublicQrCodeApi().scanningPublicQrCodeState.serializeScanningPublicQrCodeState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
